import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Building2, FileText, Phone, Mail, MapPin, Globe } from 'lucide-react';
import Footer from '../components/Footer';

const Hakkimizda = () => {
  const companyInfo = [
    {
      title: "Şirket Ünvanı",
      value: "Sigortamolsun Sigorta Aracılık Hizmetleri Limited Şirketi"
    },
    {
      title: "Vergi Dairesi",
      value: "Antalya Kurumlar"
    },
    {
      title: "Vergi No",
      value: "7700992577"
    },
    {
      title: "Ticaret Sicil No",
      value: "113558"
    },
    {
      title: "Mersis No",
      value: "0770099257700001"
    }
  ];

  const contactInfo = [
    {
      icon: Phone,
      title: "Telefon",
      value: "0544 698 0724"
    },
    {
      icon: Mail,
      title: "E-posta",
      value: "info@sigortamolsun.com"
    },
    {
      icon: Globe,
      title: "Web",
      value: "www.sigortamolsun.com"
    },
    {
      icon: MapPin,
      title: "Adres",
      value: "Ünsal, 5088. Sk. No: 22, 07080 Kepez/Antalya"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>Hakkımızda - SigortamOlsun</title>
        <meta name="description" content="SigortamOlsun şirket bilgileri ve iletişim bilgileri" />
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        {/* Şirket Bilgileri */}
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-8">
            <Building2 className="w-8 h-8 text-blue-600" />
            <h1 className="text-3xl font-bold text-gray-900">Şirket Bilgileri</h1>
          </div>
          
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-8">
              {companyInfo.map((item) => (
                <div key={item.title} className="space-y-1">
                  <div className="text-sm text-gray-500">{item.title}</div>
                  <div className="font-medium text-gray-900">{item.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* İletişim Bilgileri */}
        <div>
          <div className="flex items-center gap-3 mb-8">
            <FileText className="w-8 h-8 text-blue-600" />
            <h2 className="text-3xl font-bold text-gray-900">İletişim Bilgileri</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {contactInfo.map((item) => (
              <div 
                key={item.title}
                className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start gap-4"
              >
                <div className="rounded-lg bg-blue-50 p-3">
                  <item.icon className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <div className="text-sm text-gray-500">{item.title}</div>
                  <div className="font-medium text-gray-900">{item.value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* SBD Notu */}
        <div className="mt-12 text-center text-sm text-gray-500">
          <p>
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Hakkimizda;